import React from 'react'

import {
  Anchor,
  Gift,
  Home,
  Move,
  Package,
  Trello,
  Truck,
} from 'react-feather'

interface RouteChild {
  path: string
  name: string
  icon?: JSX.Element
  badge?: string
}

export interface Route {
  id: string
  path: string
  icon: JSX.Element
  header?: string
  badge?: string
  containsHome: boolean
  open: boolean
  children?: RouteChild[] | null
}

const homeRoute: Route = {
  id: 'Dashboards',
  path: '/',
  icon: <Trello />,
  containsHome: true,
  open: false,
  children: [
    {
      path: '/',
      name: 'Default',
    },
    {
      path: '/dashboards/os&d',
      name: 'Over, Short & Damaged',
    },
  ],
}

const facilitiesRoute: Route = {
  id: 'Facilities',
  path: '/facilities',
  icon: <Home />,
  containsHome: false,
  open: false,
}

const inventoryRoute: Route = {
  id: 'Inventory',
  path: '/inventory',
  icon: <Package />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/inventory/skus',
      name: 'SKUs',
    },
    {
      path: '/inventory/damages',
      name: 'Damages',
    },
  ],
}

const palletRoute: Route = {
  id: 'Pallets',
  path: '/pallets',
  icon: <Move />,
  containsHome: false,
  open: false,
}

const asnRoute: Route = {
  id: 'Advance Shipping Notices',
  path: '/asn',
  icon: <Anchor />,
  containsHome: false,
  open: false,
}

const freightRoute: Route = {
  id: 'freight',
  path: '/freight',
  icon: <Truck />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/freight/orders',
      name: 'Orders',
    },
    {
      path: '/freight/shipments',
      name: 'Shipments',
    },
    {
      path: '/freight/truckloads',
      name: 'Truckloads',
    },
  ],
}

const parcelRoute: Route = {
  id: 'parcel',
  path: '/parcel',
  icon: <Gift />,
  containsHome: false,
  open: false,
  children: [
    {
      path: '/parcel/orders',
      name: 'Orders',
    },
    {
      path: '/parcel/shipments',
      name: 'Shipments',
    },
  ],
}

export const menu = [
  homeRoute,
  facilitiesRoute,
  inventoryRoute,
  palletRoute,
  asnRoute,
  freightRoute,
  parcelRoute,
]
